import React from "react";
import "./intro.css";
import { Link } from "react-router-dom";
import logo_m from "../../assets/Logo_m.png";
import heroImage from "../../assets/image 2.png";

function Intro() {
  return (
    <>
      <section className="hero-section">
        <div className="hero-image-wrapper">
          <img src={heroImage} alt="Hero Banner" className="hero-image" />
          <div className="hero-dark-overlay"></div>
          <div className="hero-overlay">
            <h1 className="heading-primary">สมาคมนวัตกรรมสิ่งแวดล้อม</h1>
            <p>
              Environmental Innovation Association: EInA
            </p>
          </div>
        </div>
      </section>

      <section className="intro-section">
        <div className="container intro-content">
          <div className="intro-text">
            <h2>เกี่ยวกับเรา</h2>
            <p>
              การจัดตั้งสมาคมนวัตกรรมสิ่งแวดล้อมเป็นการรวมพลังจากผู้เชี่ยวชาญ นักวิจัย นักอุตสาหกรรม และผู้บริหารองค์กรที่มีความมุ่งมั่นในการผลักดันประเทศไทยสู่ เศรษฐกิจสีเขียว (Green Economy) และ สังคมคาร์บอนต่ำ (Low Carbon Society)
            </p>
            <Link to="/about-us" className="intro-button">
              เพิ่มเติม
            </Link>
          </div>
          <div className="intro-image">
            <img src={logo_m} alt="เกี่ยวกับเรา" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Intro;
